import { Button, Card, CardBody, CardHeader, Heading } from '@nrg/design-system';
import * as Sentry from '@sentry/react';
import type { ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

function FallbackUI({ resetError }: { resetError: () => void }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: '2rem',
      }}
    >
      <Card style={{ maxWidth: 480 }}>
        <CardHeader>
          <Heading level={2}>Something went wrong</Heading>
        </CardHeader>
        <CardBody>
          <p>An unexpected error occurred. Try again, or refresh the page.</p>
          <div style={{ marginTop: '1.5rem', display: 'flex', gap: '0.5rem' }}>
            <Button variant="primary" onClick={resetError}>
              Try again
            </Button>
            <Button variant="secondary" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default function ErrorBoundary({ children }: ErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary fallback={({ resetError }) => <FallbackUI resetError={resetError} />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
